export default __webpack_public_path__ + "static/media/loom.018a0d71.svg";